import { Component } from 'react'
import s from './Clients.scss'
import { If } from 'components/ideal-core-ui'
import cn from 'classnames'
import { withRouter } from 'hocs'
import { preventDefault, getNoBidClientStyle } from 'utils/helpers'

@withRouter
class Clients extends Component {
  navigateTo = (e, url) => {
    preventDefault(e)
    this.props.router.navigate(url)
  }

  render() {
    const { clients, dealId } = this.props
    const visibleClients = clients.slice(0, 2)
    const hiddenClients = clients.slice(2)
    return (
      <>
        <If condition={visibleClients.length}>
          <span className={s.linkWrapper}>
            {visibleClients.map(client => (
              <span
                key={client.company.id}
                className={s.link}
                onClick={e => this.navigateTo(e, `/companies/${client.company.id}`)}
                style={getNoBidClientStyle(client.company.noBid)}
              >
                {client.company.name}
                {visibleClients.length > 1 && ' | '}{' '}
              </span>
            ))}
          </span>
        </If>
        <If condition={hiddenClients.length}>
          <span
            className={cn(s.link, s.more)}
            onClick={e => this.navigateTo(e, `/opportunities/${dealId}`)}
          >
            {' '}
            + {hiddenClients.length} more
          </span>
        </If>
      </>
    )
  }
}

export default Clients
